import React, { useState, useRef } from "react";
import CustomButton from "../../components/customButton";
import axios from "axios";
import { baseUrl } from "../../utills";
import { message, Form, Row, Col, Button, Spin } from "antd";
import { CustomPasswordInput } from "../../components/customInput";
import { green } from "../../constants/colors";
import { useNavigate } from "react-router-dom";
const OtpInput = ({ length = 6, onChange, email }) => {
  const [otp, setOtp] = useState(""); // Store OTP as a string
  const [formLayout, setFormLayout] = useState("vertical");
  const [messageApi, contextHolder] = message.useMessage();
  const [form2] = Form.useForm();
  const [state, setState]=useState(true);
  const [loading, setLoading]=useState(false)
const [newPass, setNePass]=useState();
console.log("newPass:",newPass);
const navigate=useNavigate();
  const inputRefs = useRef([]);
  const formItemLayout =
  formLayout === "horizontal"
    ? {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 14,
        },
      }
    : null;
const buttonItemLayout =
  formLayout === "horizontal"
    ? {
        wrapperCol: {
          span: 14,
          offset: 4,
        },
      }
    : null;
  const handleChange = (e, index) => {
    const value = e.target.value.replace(/\D/, ""); // Allow only numbers
    if (!value) return;

    const newOtp = otp.split(""); // Convert string to array
    newOtp[index] = value;
    const otpString = newOtp.join(""); // Convert array back to string
    setOtp(otpString);

    if (index < length - 1 && value) {
      inputRefs.current[index + 1].focus();
    }

    onChange && onChange(otpString);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const submitOtp = async (values) => {
    console.log("OTP:", otp);
    const payload = {
      email: email,
      otp: otp,
    };

    try {
    setLoading(true);
      const res = await axios.post(baseUrl + "verify-otp/", payload);
      if (res.status === 200) {
    setLoading(false);
        console.log("OTP submitted successfully:", res);
        messageApi.open({
            type: "success",
            content: res?.data?.detail,
          });
          setState(false)
      }
    } catch (error) {
    setLoading(false);

      console.error("OTP verification failed:", error);
    }
  };
const submit = async(values)=>{
    const payload = {
      new_password:newPass,
        email: email,
      };
    try {
    setLoading(true);
        const res = await axios.post(baseUrl + "reset-password/", payload);
        if (res.status === 200) {
    setLoading(false);

          console.log("reset pass res:", res);
          messageApi.open({
              type: "success",
              content: res?.data?.detail,
            });
            navigate("/login")
        }
      } catch (error) {
    setLoading(false);

        console.error("reset pass failed:", error);
      }
}
  return (
    <div>
        {contextHolder}
<Spin spinning={loading}>


{state?
        <>
      <div className="flex gap-2 justify-center mb-4">
        {Array.from({ length }).map((_, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            maxLength="1"
            className="w-12 h-12 border border-gray-300 text-center text-xl rounded-md focus:outline-none focus:ring-2 focus:ring-green-500 transition-all"
            value={otp[index] || ""}
            onChange={(e) => handleChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
          />
        ))}
      </div>
      <CustomButton onClick={submitOtp} className="bg-customGreen w-full mt-8 py-6">
        Submit
      </CustomButton>
      </>
      :
      (
        <Form
        {...formItemLayout}
        layout={formLayout}
        form={form2}
        name="form2"
        // onFinish={submit}
        initialValues={{
          layout: formLayout,
        }}
      >

        <Row gutter={[23, 0]}>
          <Col xs={24}>
          <Form.Item
                label={
                  <p style={{ color: "gray", marginBottom: "0px" }}>New Password</p>
                }
                name="new_password"
                rules={[
                  { required: true, message: "Please enter your address" },
                ]}
              >
                <CustomPasswordInput onChange={(e)=>setNePass(e.target.value)} placeholder="Enter new password" />
              </Form.Item>
          </Col>
         
        </Row>
          
        
        
        <CustomButton onClick={submit} className="bg-customGreen w-full mt-8 py-6">
        Submit
      </CustomButton>
      </Form>
      )}
</Spin>
    </div>
  );
};

export default OtpInput;
